import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=72508ceb&scoped=true&"
import script from "./statistics.vue?vue&type=script&lang=js&"
export * from "./statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72508ceb",
  null
  
)

export default component.exports